/** @module AQL/QueryFilterController */
define([
    "dojo/_base/array",
    "dojo/_base/declare",
    "csi/reflection",
    "csi/xml",
    "Apparel/QueryFilterController"
], function(array,declare,reflection,xml,QueryFilterController) {

    /** @property {Object} linkingTypeMap - Maps enum from InspectionTestNode to class type */
    const linkingTypeMap = {
        BOM: "PartMaterial",
        SizeChart: "SizeChartDimension",
        SpecDataSheet: "SpecificationDataSheetItem"
        };

    return declare(QueryFilterController,{
        /**
         * @override
         * Gets type for query search from InspectionTestSpec node
         */
        onStart: function() {
            var node = this._getTestSpec();
            var linkingType = xml.enumGetText(node.LinkingType);
            this.queryFilterStartType = this.queryFilterType = linkingTypeMap[linkingType] || linkingType;
        },

        /**
         * Get InspectionTestSpec node
         * @return {InspectionTestSpec} InspectionTestSpec node
         */
        _getTestSpec: function() {
            return this.getCache().getNode(this.getNode().__Parent__);
        }
    });
});